// extracted by mini-css-extract-plugin
export default {"errorText":"ggaoGla78I0JEcVESv3Q"};